import { useEffect, useState } from "react";
import Api from "lib/api/httpRequestHelper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { AttachFile, Close, Engineering, Paid } from "@mui/icons-material";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { Divider } from "@mui/material";

export default function DatasheetCard({ id, close }) {
  const [searching, setSearching] = useState(false);
  const [data, setData] = useState({});

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    try {
      const response = await Api.get(
        "product-search-details",
        "product",
        "?idProduto=" + id,
        true
      );
      setData(response.Result.ProdutoDetalhes);
      console.log(response.Result.ProdutoDetalhes);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações do produto:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const engineeringInfo = [
    {
      label: "Código do Produto",
      value: data?.Produto,
    },
    {
      label: "Código de Barras",
      value: data?.CodigoBarras,
    },
    {
      label: "NCM",
      value: data?.Ncm,
    },
    {
      label: "Linha Comercial",
      value: data?.LinhaComercial,
    },
    {
      label: "Marca",
      value: data?.MarcaProduto,
    },
    {
      label: "Coleção",
      value: data?.ColecaoProduto,
    },
    {
      label: "Nome Comercial",
      value: data?.NomeComercial,
    },
    {
      label: "Descrição Acabamento",
      value: data?.DescricaoAcabamento,
    },
    {
      label: "Peso",
      value: data?.Peso,
    },
    {
      label: "País de Origem",
      value: data?.PaisOrigem,
    },
    {
      label: "Origem Fiscal",
      value: data?.OrigemFiscal,
    },
    {
      label: "Unidade de Medida",
      value: data?.UnidadeMedida,
    },
    {
      label: "Formato",
      value: data?.Formato,
    },
    {
      label: "Tecido Base",
      value: data?.TecidoBase,
    },

    {
      label: "Preço",
      value: data?.PrecoFormat,
    },
    {
      label: "Preço Promocional",
      value: data?.PrecoPromoFormat,
    },
  ];

  const fiscalInfo = [
    {
      label: "CST",
      value: data?.cst,
    },
    {
      label: "CST PIS",
      value: data?.cst_pis,
    },
    {
      label: "CEST",
      value: data?.cest,
    },
    {
      label: "Alíquota IPI",
      value: data?.aliq_ipi,
    },
  ];

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={close} maxWidth={"md"}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <AttachFile style={{ marginRight: "12px" }} />
            Ficha Técnica
          </Typography>
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados da ficha técnica..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                color="primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                Engenharia
                <Engineering style={{ marginLeft: 8 }} />
              </Typography>

              <Divider />

              {engineeringInfo?.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                color="primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                Fiscal
                <Paid style={{ marginLeft: 8 }} />
              </Typography>

              <Divider />

              {fiscalInfo?.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      )}

      <DialogActions>
        <Button variant="contained" color="primary" onClick={close}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
